<template>
  <div>
    <div
      class="mb-3 text-h3 font-medium"
      :class="$store.state.mobile ? '' : 'mt-4'"
    >
      <template v-if="$store.getters.languageGetter === '1'">
        إعدادات الحساب
      </template>
      <template v-else>
        Account Settings
      </template>
    </div>
    <v-divider />
    <v-form
      ref="formProfile"
      v-model="validProfile"
      lazy-validation
    >
      <v-row>
        <v-col
          :cols="$store.state.mobile ? 12 : 3"
          class="mt-5"
        >
          <template v-if="$store.getters.languageGetter === '1'">
            تغيير ملف التعريف الخاص بك
          </template>
          <template v-else>
            Change your Profile
          </template>
        </v-col>
        <v-col :cols="$store.state.mobile ? 12 : 6">
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="name"
                :rules="nameRules"
                :label="$store.getters.languageGetter === '1' ? 'اسم' : 'Name'"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-btn
            :loading="submittingProfile"
            color="#f51414"
            depressed
            dark
            class="mb-2"
            @click="changeName"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              يحفظ
            </template>
            <template v-else>
              Save
            </template>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-divider class="mb-3" />
    <v-form
      ref="formEmail"
      v-model="validEmail"
      lazy-validation
    >
      <v-row>
        <v-col
          :cols="$store.state.mobile ? 12 : 3"
          class="mt-3"
        >
          <template v-if="$store.getters.languageGetter === '1'">
            تغيير عنوان البريد الإلكتروني الخاص بك
          </template>
          <template v-else>
            Change your Email address
          </template>
        </v-col>
        <v-col :cols="$store.state.mobile ? 12 : 6">
          <v-text-field
            v-model="email"
            :rules="emailRules"
            :label="$store.getters.languageGetter === '1' ? 'عنوان البريد الإلكتروني الجديد' : 'New Email Address'"
            outlined
            dense
          />
          <v-btn
            :loading="submittingEmail"
            color="#f51414"
            depressed
            dark
            class="mb-2"
            @click="changeEmail"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              يحفظ
            </template>
            <template v-else>
              Save
            </template>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-divider class="mb-3" />
    <v-form
      ref="formPassword"
      v-model="validPassword"
      lazy-validation
    >
      <v-row>
        <v-col
          :cols="$store.state.mobile ? 12 : 3"
          class="mt-3"
        >
          Change your Password
        </v-col>
        <v-col :cols="$store.state.mobile ? 12 : 6">
          <v-text-field
            v-model="password"
            :rules="passwordRules"
            :append-icon="eye1 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="eye1 ? 'text' : 'password'"
            :label="$store.getters.languageGetter === '1' ? 'كلمة السر الموجودة حاليا' : 'Exsiting Password'"
            outlined
            dense
            @click:append="eye1 = !eye1"
          />
          <v-text-field
            v-model="newPassword"
            :rules="passwordRules"
            :append-icon="eye2 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="eye2 ? 'text' : 'password'"
            :label="$store.getters.languageGetter === '1' ? 'كلمة السر الجديدة' : 'New Password'"
            outlined
            dense
            @click:append="eye2 = !eye2"
          />
          <v-text-field
            v-model="confirmPassword"
            :rules="confirmPasswordRules"
            :append-icon="eye3 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="eye3 ? 'text' : 'password'"
            :label="$store.getters.languageGetter === '1' ? ' المرورتأكيد كلمة ' : 'Confirm Password'"
            outlined
            dense
            @click:append="eye3 = !eye3"
          />
          <v-btn
            :loading="submittingPassword"
            color="#f51414"
            depressed
            dark
            class="mb-2"
            @click="changePassword"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              يحفظ
            </template>
            <template v-else>
              Save
            </template>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'UserAccountSettings',
  data() {
    return {
      validProfile: true,
      validEmail: true,
      validPassword: true,
      name: '',
      nameRules: [(v) => !!v || 'Please enter your name'],
      password: '',
      passwordRules: [(v) => !!v || 'Please enter your password', (v) => v.length >= 6 || 'Password should be more than 6 characters'],
      newPassword: '',
      confirmPassword: '',
      confirmPasswordRules: [
        (v) => !!v || 'Please confirm your password',
        (v) => v === this.newPassword || 'Passwords are not the same',
      ],
      email: '',
      emailRules: [(v) => !!v || 'Please enter your email', (v) => /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/.test(v)
          || 'This is not a correct email address'],
      eye1: false,
      eye2: false,
      eye3: false,
      submittingProfile: false,
      submittingEmail: false,
      submittingPassword: false,
    };
  },
  computed: {
    ...mapState(['user']),
  },
  created() {
    this.name = this.user.userName;
    this.email = this.user.email;
  },
  methods: {
    ...mapActions('center', ['setAccountAsync', 'setPasswordAsync']),
    changeName() {
      if (this.$refs.formProfile.validate()) {
        this.submittingProfile = true;
        const params = this.user;
        params.userName = this.name;
        this.setAccountAsync({ id: this.user.id, userName: this.name, params }).finally(() => {
          this.submittingProfile = false;
        });
      }
    },
    changeEmail() {
      if (this.$refs.formEmail.validate()) {
        this.submittingEmail = true;
        const params = this.user;
        params.email = this.email;
        this.setAccountAsync({
          id: this.user.id, userName: params.userName, email: this.email, params,
        }).finally(() => {
          this.submittingEmail = false;
        });
      }
    },
    changePassword() {
      if (this.$refs.formPassword.validate()) {
        this.submittingPassword = true;
        const account = JSON.parse(this.$store.$cookie.get('account'));
        const extPassword = account.password;
        if (this.$store.$md5(this.password) !== extPassword) {
          this.$store.commit('TOGGLE_SNACKBAR',
            {
              type: 'error',
              text: this.$store.getters.languageGetter === '1' ? 'كلمة المرور الحالية غير صحيحة ، تحقق من فضلك' : 'Exsiting password is not correct, check please',
            });
          this.submittingPassword = false;
          return;
        }
        const newPassword = this.$store.$md5(this.newPassword);
        this.setPasswordAsync({ id: this.user.id, passwords: newPassword, params: this.user }).then(() => {
          this.$store.$cookie.set('account', JSON.stringify({
            account: account.account,
            password: this.$store.$md5(this.newPassword),
          }));
        }).finally(() => {
          this.submittingPassword = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
